import { LivingComplex } from '../../entities/LivingComplex'
import { apiRequest } from '../client'

export const fetchLivingComplex = async (
  livingComplexId: string
): Promise<LivingComplex> => {
  const response = await apiRequest(`/livingcomplex/${livingComplexId}`, {
    method: 'GET'
  })

  if (response.status === 404) {
    throw new Error('ЖК не найден')
  }

  if (!response.ok) {
    throw new Error('Не удалось загрузить данные по ЖК')
  }

  return (await response.json()) as LivingComplex
}
